import { BeatSequencer } from '@/story/sequencer';
import type { Beat } from '@/story/types';
import type { BeatFadeCues } from '@/world/beatFadeDirector';
import type { BeatPartCapabilities, BeatPartModule, BeatPartTick } from '@/game/beatPartModule';

export interface FadeStoryPartDefinition {
  readonly beat: Beat;
  readonly cues: BeatFadeCues;
  readonly fixedStep: (tick: BeatPartTick) => void;
}

/** The common story-and-fade shell; local modules supply only their fixed rule. */
export function fadeStoryPart(definition: FadeStoryPartDefinition): (capabilities: BeatPartCapabilities) => BeatPartModule {
  return (capabilities): BeatPartModule => {
    const story = new BeatSequencer(definition.beat);
    const fade = capabilities.createFade(definition.cues);
    let disposed = false;
    return {
      story,
      interactables: [],
      get fade(): number { return fade.fade; },
      get promptSuppressed(): boolean { return !disposed && fade.fade > 0.5; },
      fixedStep: definition.fixedStep,
      handleCue(cue): void { fade.handle(cue); },
      renderStep(frameDt): void { if (!disposed) fade.update(frameDt); },
      dispose(): void {
        if (disposed) return;
        disposed = true;
        fade.dispose();
      },
    };
  };
}
